import React from 'react';

import { Sub2Typography } from '../../Typography';

import theme from '$/assets/theme';

export interface ISubTitleProps {
  style?: React.CSSProperties;
}

const Subtitle: React.FC<ISubTitleProps> = ({ children, ...props }) => (
  <Sub2Typography
    as="h3"
    {...props}
    style={{
      margin: '16px 8px 8px',
      color: theme.colors.grey5,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '13px',
      ...(props.style ?? {}),
    }}
  >
    {children}
  </Sub2Typography>
);

export default Subtitle;
